var map = {
	"./Adventurer.svg": 8013,
	"./Aggressive.svg": 695,
	"./AnyResource.svg": 5203,
	"./BlueStar.svg": 8639,
	"./Book.svg": 1076,
	"./CaveCard.svg": 7878,
	"./Coin.svg": 9464,
	"./Crystal.svg": 8503,
	"./DragonCard.svg": 688,
	"./DragonGuild.svg": 8191,
	"./Egg.svg": 7486,
	"./EggCapacity.svg": 1946,
	"./EndGame.svg": 5324,
	"./FledglingArrow.svg": 1100,
	"./Gold.svg": 2237,
	"./Helpful.svg": 2499,
	"./Meat.svg": 5922,
	"./Milk.svg": 5834,
	"./NoResourceCost.svg": 4861,
	"./OncePerRound-v2.svg": 7248,
	"./OncePerRound.svg": 7863,
	"./Playful.svg": 4774,
	"./Shy.svg": 4515,
	"./VP.svg": 7389,
	"./WhenPlayed.svg": 4486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;